import React, { useEffect, useState,useMemo } from "react";
import { Secured } from "../../component";
import { Permissions } from "../../Constantes/permissions.constants";
import moment from "moment";
import services from "./services";
import {
    useTable,
    useSortBy,
    useFilters,
  } from "react-table";
  import {formatCpf } from "../../helper/util";
import {
  Form,
  Card,
  Row,
  Button,
  Modal
} from "antd";


const HistoricoBloqueio = () => {

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [registroSelecionado, setRegistroSelecionado] = useState(null);
  const [seguradosData, setSeguradosData] = useState([]);
  


  const handleOpenModal = (row) => {
    const registro = row.original;
    setLoadingModal(true);

    services.getListaBloqueadosPorHistorico(registro.id)
      .then((response) => {
        registro.segurados = response.data;
  
        setSeguradosData(registro.segurados || []);
  
        setRegistroSelecionado(registro);
      })
      .catch(() => {
        console.error("Erro ao buscar segurados.");
        setSeguradosData([]);
        setRegistroSelecionado(registro);
        setIsModalVisible(true);
      }).finally(() => {
        setLoadingModal(false);
        setIsModalVisible(true);
      });
  };
  
  const handleCloseModal = () => {
    setIsModalVisible(false);
    setRegistroSelecionado(null);
    setSeguradosData([]);
  };

  const monthNames = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
  ];

    const [form] = Form.useForm();

    const [historicoBloqueio, setHistoricoBloqueio] = useState([]);

    const today = new Date();
    const currentMonth = monthNames[new Date().getMonth()];

    useEffect(() => {
      const params = { 
        mes:today.getMonth()+1,
        ano:today.getFullYear()
      };
      
      services
        .getListHistoricoBloqueio(params)
        .then((response) => {
          let historicoBloqueio = response.data;
          setHistoricoBloqueio(historicoBloqueio);
        })
        .catch((error) => {
          let errorMessage = "Erro ao buscar histórico de bloqueios.";

          if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
          }
        })
     
    }, []);

    const DefaultColumnFilter = ({ column: { filterValue, setFilter } }) => {
      return (
        <input
          value={filterValue || ""}
          onChange={(e) => setFilter(e.target.value || undefined)}
          onClick={(e) => e.stopPropagation()}
          placeholder={`Filtrar...`}
          style={{ width: "100%" }}
        />
      );
    };

    const columns = useMemo(
        () => [
          {
            Header: "Usuário",
            accessor: "nomeUsuario",
            Filter: DefaultColumnFilter,
            className: "text-center",
          },
          {
            Header: "Data/Hora",
            id: "dataRealizacao",
            accessor: "dataFormatada",
            Filter: DefaultColumnFilter,
            className: "text-center",
          },
          {
            Header: "Tipo",
            id: "tipo",
            accessor: "tipo.tipo",
            Filter: DefaultColumnFilter,
            className: "text-center",
          },
          {
            id: "acao",
            disableFilters: true,
            className: "text-center",
            Cell: ({ row }) => (
              <button
                className="btn btn-outline button-table"
                title="Visualizar Detalhes"
                onClick={() => handleOpenModal(row)}
              >
                <i className="fa fa-eye fa-fw" />
              </button>
            ),
          }          
        ],
        [historicoBloqueio]
      );

  const seguradosColumns = useMemo(
  () => [
    {
      Header: "CPF",
      accessor: "cpf",
      Filter: DefaultColumnFilter,
      Cell: ({ value }) => formatCpf(value),
      className: "text-center",
    },
    {
      Header: "Nome",
      accessor: "nome",
      Filter: DefaultColumnFilter,
      className: "text-center",
    },
    {
      Header: "Nome da Mãe",
      accessor: "nomeMae",
      Filter: DefaultColumnFilter,
      className: "text-center",
    },
    {
      Header: "Data de Nascimento",
      accessor: "dataNascimento",
      Filter: DefaultColumnFilter,
      Cell: ({ value }) => moment(value).format("DD/MM/YYYY"),
      className: "text-center",
    },
  ],
  []
);


  const defaultColumn = useMemo(
    () => ({
      Filter: DefaultColumnFilter,
      }),
      []
      );
        
  const {
    getTableProps,
    getTableBodyProps,
            headerGroups,
            rows,
            prepareRow,
          } = useTable(
            {
              columns,
              data: historicoBloqueio,
              defaultColumn,
            },
            useFilters,
            useSortBy
          );

const {
  getTableProps: getSeguradosTableProps,
  getTableBodyProps: getSeguradosBodyProps,
  headerGroups: seguradosHeaderGroups,
  rows: seguradosRows,
  prepareRow: prepareSeguradosRow,
} = useTable(
  {
    columns: seguradosColumns,
    data: seguradosData,
    defaultColumn,
  },
  useFilters,
  useSortBy
);


return (
    <>
    <Secured
        hasAnyRole={Permissions.RECADASTRAMENTO.TELA}
        isShowErro403={true}
      > <h1>Histórico</h1>
        <Form layout="vertical" form={form}>
        <Card title={`Histórico de bloqueio referente ao mês de ${currentMonth}`}><br/>
            <Row>
              <div className="col-lg-12">
                  <div className="panel panel-default">
                    <div className="panel-body">
                      <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                        <table {...getTableProps()} className="table table-striped">
                          <thead>
                          {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                              {headerGroup.headers.map((column) => (
                                <th
                                  {...column.getHeaderProps(column.getSortByToggleProps())} className={column.className} 
                                  style={{
                                    position: "sticky",
                                    top: 0,
                                    background: "#fff",
                                    zIndex: 1,
                                  }}
                                >
                                  {column.render("Header")}
                                  <span>
                                    {column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}
                                  </span>
                                  <div>
                                    {historicoBloqueio.length > 0 && column.canFilter ? column.render("Filter") : null}
                                  </div>
                                </th>
                              ))}
                            </tr>
                          ))}
                          </thead>
                          <tbody {...getTableBodyProps()}>
                            {rows.length > 0 ? (
                              rows.map((row) => {
                                prepareRow(row);
                                return (
                                  <tr {...row.getRowProps()} key={row.id}>
                                    {row.cells.map((cell) => (
                                      <td {...cell.getCellProps()}  className={cell.column.className}  style={{ textAlign: "center" }}>{cell.render("Cell")}</td>
                                    ))}
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan={columns.length} className="text-center">
                                  Não foram efetuado(s) Bloqueio(s) para o mês de referência
                                </td>
                              </tr>
                          )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
            </Row>
          </Card>
        </Form>


        <Modal
          title="Detalhes do Bloqueio"
          visible={isModalVisible}
          confirmLoading={loadingModal}
          onCancel={handleCloseModal}
          footer={[
            <Button key="close" onClick={handleCloseModal}>
              Fechar
            </Button>,
          ]}
          width="95vw"
          style={{
            top: 80,
            maxWidth: "1140px",
            margin: "0 auto",
            padding: 0,
          }}
          bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
          maskClosable={false}
          keyboard={false}
        >

          {registroSelecionado && (
          <>
            <p><strong>Usuário:</strong> {registroSelecionado.nomeUsuario}</p>
            <p><strong>Data/Hora:</strong> {registroSelecionado.dataFormatada}</p>
            <p><strong>Tipo:</strong> {registroSelecionado.tipo?.tipo}</p>

            <hr />
            <h4>Segurados Bloqueados</h4>

            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
              <table {...getSeguradosTableProps()} className="table table-bordered">
                <thead>
                  {seguradosHeaderGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(column.getSortByToggleProps())}
                          className={column.className}
                          style={{
                            position: "sticky",
                            top: 0,
                            background: "#fff",
                            zIndex: 1,
                          }}
                        >
                          {column.render("Header")}
                          <span>
                            {column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}
                          </span>
                          <div>
                            {seguradosData.length > 0 && column.canFilter ? column.render("Filter") : null}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getSeguradosBodyProps()}>
                  {seguradosRows.map((row) => {
                    prepareSeguradosRow(row);
                    return (
                      <tr {...row.getRowProps()} key={row.id}>
                        {row.cells.map((cell) => (
                          <td {...cell.getCellProps()} className={cell.column.className}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              {seguradosData.length === 0 && (
                <p style={{ textAlign: "center" }}>Nenhum segurado para exibição.</p>
              )}
            </div>
            </>
          )}
        </Modal>

      </Secured>

    </>)
    
}
export default HistoricoBloqueio;